export const lensAddresses = {
  accountLens: "0xfC09040C5E26aec5E55a93F6856159A0C28ffDB9",
  eulerEarnVaultLens: "0x76e9Afa9BF60BA0910F2139E3282e767a6433170",
  irmLens: "0x743678dAE1d3358965ACAae333F8BADE1952723a",
  oracleLens: "0x0c0519BaA6c1556f9d4dc9E26073D1BF7C48DC2e",
  utilsLens: "0x2943d685b1d3C97b3F0e64f2100c7fD81a8DF905",
  vaultLens: "0x2ffd260BAd257C08516B649c93Ea3eb6b63a5639",
} as const
